import React from "react";
import { EmptyState } from "../../../../ForBrands/ui/BrandUI";
import CollapsibleCard from "../../../../ForBrands/ui/CollapsibleCard";
import InsightList from "../../../../ForBrands/ui/InsightList";
import { LegendRow } from "../../../../ForBrands/ui/LegendItem";
import PairedBars from "../../../../ForBrands/ui/charts/PairedBars";
import { CHART, ROLE } from "../../../../ForBrands/ui/charts/chartTokens";
import { fixed } from "../../../../../utils/perfFormat";
import { NO_PATTERN, fourFactorRows } from "../teamPerformanceModel";
import { EdgeTag } from "./perfPieces";

// Four Factors (BUILD_SPEC B7, Jayson's T4): per factor, the squad's bar
// (bm-orange) over what its opponents managed against it (bm-muted), the
// peer median as an ink tick with its value printed under the track (the
// mock's tooltip, as text), Edge or Deficit on the right, then the
// payload's reads in payload order. With no factors on file the card says
// so in the tab's empty state (no legend, no "No notable pattern" twice).

const FourFactorsCard = ({ payload, squadLabel, collapse }) => {
  const rows = fourFactorRows(payload);
  const legend = [
    { key: "squad", swatch: "bar", color: ROLE.self, label: squadLabel },
    { key: "opponents", swatch: "bar", color: ROLE.opponent, label: "Opponents (allowed)" },
    { key: "median", swatch: "tick", color: CHART.ink, label: "Peer median" },
  ];
  return (
    <CollapsibleCard title="Four Factors" titleAs="h3" {...collapse}>
      {rows.length ? (
        <>
          <LegendRow items={legend} label="Four factors legend" />
          <div className="flex flex-col gap-4">
            {rows.map((r) => (
              <PairedBars
                key={r.key}
                label={r.label}
                right={<EdgeTag edge={r.edge} />}
                bars={[
                  { key: "squad", label: squadLabel, value: r.team, color: ROLE.self },
                  { key: "opponents", label: r.opponentsLabel, value: r.opponents, color: ROLE.opponent },
                ]}
                median={r.median}
                medianLabel={r.median === null ? undefined : `Peer median ${fixed(r.median, 1)}`}
                scale={r.scale}
              />
            ))}
          </div>
        </>
      ) : (
        <EmptyState>No four factors on file for this squad.</EmptyState>
      )}
      <InsightList insights={payload?.four_factors?.insights} variant="callout" emptyText={rows.length ? NO_PATTERN : undefined} />
    </CollapsibleCard>
  );
};

export default FourFactorsCard;
